module.exports = __webpack_public_path__ + "files/59529ac82fe6d0253ec4ea75dbb88af9.png";